import { get, post, postNoAuth } from './axios';
import { ConsumerLocale } from '../types/ConsumerLocale';
import { ConsumerToggle, ConsumerToggleResponse } from '../types/ConsumerToggle';

const detectLanguage = async (text: string | null, auth0IdToken: string | null, consumerId: string | null) => {
	if (!text) {
		return null;
	}
	const res = await post(`/linguistnow/resources/v1/ea/detectLocale?q=${consumerId}`, {
			translationType: 'machine',
			text: text
		},
		auth0IdToken);
	return res?.detectedLanguage;
};

const getSupportedLanguages = async (auth0IdToken: string | null, consumerId: string | null): Promise<ConsumerLocale[] | []> => {
	const response = await get(
		`/linguistnow/resources/v1/ea/consumerLocaleIdsWithDisplayNames?q=${consumerId}`, auth0IdToken
	);
	const languages = response as [ConsumerLocale];
	return languages.sort((a: ConsumerLocale, b: ConsumerLocale) => a.name.localeCompare(b.name));
};

const getConsumerToggleOptions = async (auth0IdToken: string | null): Promise<ConsumerToggleResponse | null> => {
	const response = await get(
		'/linguistnow/resources/v1/ea/consumerToggleOptions', auth0IdToken
	);

	const consumerToggleResponse = response as ConsumerToggleResponse;

	if (consumerToggleResponse?.consumerToggleOptions) {
		consumerToggleResponse.consumerToggleOptions.sort((a: ConsumerToggle, b: ConsumerToggle) =>
			a.name.localeCompare(b.name)
		);
	}
	return consumerToggleResponse;
};

const sendEmailActivation = async (email: string) => {
	try {
		await postNoAuth(`/linguistnow/resources/v1/ea/sendActivationEmail?email=${encodeURIComponent(email)}`, {});
	} catch (e) {
		throw e;
	}
};

const translateText = async (
	text: string,
	sourceLocale: string | null | undefined,
	targetLocale: string | null | undefined,
	responseId: string | null = null,
	auth0IdToken: string | null,
	consumerId: string | null,
) => {
	const translateRequest = {
		sourceContent: text,
		sourceLocale: sourceLocale,
		targetLocale: targetLocale,
		rnResponseProjectId: responseId,
		contentTypeName: 'browser',
		translationType: 'machine',
		incidentId: 'Chrome Plugin',
		textType: 'text',
		threadTypeId: 15,
		translationIterationId: 1,
		userTypeId: 3
	};
	const translateResponse = await post(`/linguistnow/resources/v1/ea/translate?q=${consumerId}`, translateRequest, auth0IdToken);
	console.debug('translateResponse', translateResponse);
	return translateResponse;
};

export {
	detectLanguage,
	getSupportedLanguages,
	translateText,
	getConsumerToggleOptions,
	sendEmailActivation
};
